import defaultAttributes from '../defaultAttributes';

const Strikethrough = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M16 4H9a3 3 0 00-2.83 4' }],
    ['path', { d: 'M14 12a4 4 0 010 8H6' }],
    ['line', { x1: '4', y1: '12', x2: '20', y2: '12' }],
  ],
];

export default Strikethrough;
